import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Helmet } from 'react-helmet';

import { TextareaWithConfirm } from 'shared-components';

import { ApplicationState } from '../../../../../store';
import * as StudentActions from '../../../../../store/student/actions';
import * as VPFActions from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';
import {
  createNavigateBackwardAction,
  createNavigateForwardAction,
  createNavigateToAction
} from '../../../../../middleware/actions';
import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { toggleTaskMenu } from '../../../../../store/ui/actions';
import { titleAppend } from '../../../../../utilities/head';

const VisaPrepFormFeedbackPage1 = () => {
  // dispatch actions
  const dispatch = useDispatch();
  const onPrevious = () => dispatch(createNavigateBackwardAction());
  const onNext = () => {
    dispatch(StudentActions.saveVisaPrepForm(Pages.PAGE8));
    dispatch(createNavigateToAction('/dashboard'));
  };
  const onSkip = () => dispatch(createNavigateForwardAction());
  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(VPFActions.createUpdateVPIFieldAction(fieldName, value, refValue));
  const onBackToTaskList = () => {
    dispatch(createNavigateToAction('/dashboard'));
    dispatch(toggleTaskMenu(false));
  };

  // state props from store
  const visaPrepForm = useSelector(({ student }: ApplicationState) => student.visa, shallowEqual);
  const { otherFeedback, difficultiesFeedback } = visaPrepForm;

  // constants
  const currentStep = 1;
  const steps = 1;
  const sectionTitle = 'Feedback';

  // component state
  const complete = true;

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onPrevious={onPrevious}
      onNext={onNext}
      onSkip={onSkip}
      onBackToTaskList={onBackToTaskList}
      section={sectionTitle}
    >
      <Helmet>
        <title>
          {`${sectionTitle}: Step ${currentStep}`} {titleAppend}
        </title>
      </Helmet>

      <TextareaWithConfirm
        key={VQ.OTHER_FEEDBACK}
        id={VQ.OTHER_FEEDBACK}
        value={otherFeedback}
        label={'Is there any other information you wish to be considered as part of your application?'}
        onChange={(evt: any) => onChange(VQ.OTHER_FEEDBACK, evt.currentTarget.value)}
      />

      <TextareaWithConfirm
        key={VQ.DIFFICULTIES_FEEDBACK}
        id={VQ.DIFFICULTIES_FEEDBACK}
        value={difficultiesFeedback}
        label={'If you have any difficulties with any question or require clarity, please list the question here:'}
        onChange={(evt: any) => onChange(VQ.DIFFICULTIES_FEEDBACK, evt.currentTarget.value)}
      />
    </QuestionPage>
  );
};
export default VisaPrepFormFeedbackPage1;
